import { useAuth } from "../context/AuthContext";

export function Logo({ className = "h-8", forceDark = false }) {
  const { theme } = useAuth();
  const dark = forceDark || theme === "dark";
  return (
    <img src={dark ? "/ep-group-logo-dark.png" : "/ep-group-logo.png"} alt="EP Group" width={266} height={90}
      className={`${className} block w-auto max-w-none shrink-0 self-start object-contain`} style={{ aspectRatio: "266 / 90" }} data-testid="ep-group-logo" />
  );
}
